import React from "react";

import "../css/AtomSpinner.css";
import { SpinnerDisplayMode, SpinnerOpacityLevel } from "./constants";


interface AtomSpinnerProps {
  // Define any props here if needed, for example, size or color
  size?: number,
  color?: string,
  displayMode?: SpinnerDisplayMode,
  opacityLevel?: SpinnerOpacityLevel,
  overlayMessage?: string,
}

const AtomSpinner: React.FC<AtomSpinnerProps> = ( { 
  size = 60, 
  color = "#333", 
  displayMode = SpinnerDisplayMode.INLINE,
  opacityLevel = SpinnerOpacityLevel.HIGH,
  overlayMessage 
}: AtomSpinnerProps ) => {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`
  };

  const dotStyle = {
    backgroundColor: color
  };

  const spinnerElement = (
    <div className="atom-spinner" style={spinnerStyle}>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
    </div>
  );

  // Return inline spinner if displayMode is INLINE
  if (displayMode === SpinnerDisplayMode.INLINE) {
    return spinnerElement;
  }

  // For all overlay modes, construct overlay classes
  const overlayClasses = [
    'atom-spinner-overlay',
    `opacity-${opacityLevel}`,
  ];

  // Add specific overlay positioning class
  switch (displayMode) {
    case SpinnerDisplayMode.SCREEN_OVERLAY:
      overlayClasses.push('screen-overlay');
      break;
    case SpinnerDisplayMode.CHAT_OVERLAY:
      overlayClasses.push('chat-overlay');
      break;
    case SpinnerDisplayMode.PRESENTATION_OVERLAY:
      overlayClasses.push('presentation-overlay');
      break;
  }

  return (
    <div className={overlayClasses.join(' ')}>
      <div className="atom-spinner-overlay-content">
        {spinnerElement}
        {overlayMessage && (
          <div className="atom-spinner-overlay-message">
            {overlayMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default AtomSpinner;
